import React, { Component, PropTypes } from 'react';
import { PageModuleActions, AuthActions } from 'actions';
import { Paper, Dialog, FlatButton, CircularProgress } from 'material-ui';
import Controls from 'components/PageModule/Controls';
import DialogPortal from 'components/DialogPortal';
import { FlexBox } from 'components';
import styles from 'components/Page/Module/Styles';

export default class PageModule extends Component {
  static propTypes = {
    user: PropTypes.object,
    mode: PropTypes.oneOf(['detail', 'edit']),
    style: PropTypes.object,
    editor: PropTypes.bool,
    reader: PropTypes.bool,
    params: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    children: PropTypes.node,
    content: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
      PropTypes.string
    ]),
    userdata: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    moduleId: PropTypes.number
  };

  static contextTypes = {
    muiTheme: PropTypes.object,
    getIntlMessage: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      mouseOver: false
    };
  }

  componentDidMount() {
    if (this.onInit) {
      this.onInit();
    }
  }

  handleModeChange = () => {
    this.save();
  };

  getModuleData(content, data) {
    return {
      ...data
    };
  }

  getContent(content, data) {
    return content;
  }

  getUserData(userdata) {
    return {
      ...userdata
    };
  }

  getStyle() {
    const { mouseOver } = this.state;
    const { style, mode } = this.props;
    return Object.assign(
      {},
      styles.root,
      style,
      mode === 'edit' ? styles.edit : null,
      mouseOver && mode === 'edit' ? styles.hover : null
    );
  }

  listenToActions() {
    this.listenToAction(AuthActions.readerMode, this.handleModeChange);
  }

  createControls() {
    const { mode, params, moduleName } = this.props;
    return (
      <FlexBox style={styles.toolbar} row>
        <FlexBox />
        <FlexBox grow={0} shrink={0}>
          <Controls
            style={styles.toolbarGroup}
            onSave={::this.save}
            onDelete={::this.askForDelete}
            onEditMode={::this.changeToEditMode}
            mode={mode}
            raw={params.hasOwnProperty('raw') ? params.raw : false}
            moduleName={moduleName}
          />
        </FlexBox>
      </FlexBox>
    );
  }

  handleMouseEnter() {
    this.setState({ mouseOver: true });
  }

  handleMouseLeave() {
    this.setState({ mouseOver: false });
  }

  askForDelete() {
    this.refs.confirmDialog.show();
  }

  cancelDelete() {
    this.refs.confirmDialog.dismiss();
  }
  clearUserData() {
    PageModuleActions.savePageModuleUserData(this.props.moduleId, {});
  }

  deleteModule() {
    PageModuleActions.deletePageModule(this.props.moduleId);
  }

  changeToEditMode() {
    this.onEdit();
    if (this.props.onEdit) {
      this.props.onEdit();
    }
    PageModuleActions.changePageModuleMode(this.props.moduleId, 'edit');
  }

  onEdit() {}

  changeToDetailMode() {
    this.onDetail();
    if (this.props.onDetail) {
      this.props.onDetail();
    }
    PageModuleActions.changePageModuleMode(this.props.moduleId, 'detail');
  }

  onDetail() {}

  saveUserData() {
    const { userdata } = this.props;
    const dataToSave = this.getUserData(userdata);
    PageModuleActions.savePageModuleUserData(this.props.moduleId, dataToSave);
  }

  save({isCancelResize = false, switchBack = true} = {}) {
    const { content, params } = this.props;
    const dataToSave = this.getModuleData(content, params);
    const contentToSave = this.getContent(content, params);
    dataToSave.raw = isCancelResize;

    PageModuleActions.savePageModule(
      this.props.moduleId,
      contentToSave,
      dataToSave
    );
    if (switchBack) {
      this.changeToDetailMode();
    }
  }

  autoSave() {
    PageModuleActions.markModuleSaving(this.props.moduleId);
    if (this._saveTimer) {
      clearTimeout(this._saveTimer);
    }
    this._saveTimer = setTimeout(() => {
      this.save({switchBack: false});
    }, 1000);
  }

  renderEditMode(content, data, userdata) {
    console.log(content, data, userdata);
  }

  renderDetailMode(content, data, userdata) {
    console.log(content, data, userdata);
  }

  render() {
    const {
      mode,
      saving,
      editor,
      content,
      params,
      userdata,
      children
    } = this.props;
    let dialog;
    let pageModule;
    let controls;
    if (editor) {
      controls = this.createControls();
      const standardActions = [
        <FlatButton
          key="cancel"
          label={this.context.getIntlMessage('No')}
          primary
          onTouchTap={::this.cancelDelete}
        />,
        <FlatButton
          key="ok"
          label={this.context.getIntlMessage('Yes')}
          secondary
          onTouchTap={::this.deleteModule}
        />
      ];

      dialog = (
        <DialogPortal>
          <Dialog
            ref="confirmDialog"
            title={this.context.getIntlMessage('Remove')}
            actions={standardActions}
            dismissOnClickAway
          >
            {this.context.getIntlMessage('module.confirmDelete')}
          </Dialog>
        </DialogPortal>
      );
    }
    const savingIcon = (
      <div style={styles.saving}>
        <CircularProgress size={0.5} mode="indeterminate" />
      </div>
    );
    if (mode === 'edit' && editor) {
      pageModule = this.renderEditMode(content, params || {}, userdata);
    } else {
      pageModule = this.renderDetailMode(content, params || {}, userdata);
    }
    return (
      <div
        style={this.getStyle()}
        onMouseEnter={::this.handleMouseEnter}
        onMouseLeave={::this.handleMouseLeave}
      >
        {controls}
        {pageModule}
        {children}
        {saving && savingIcon}
        {dialog}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/PageModule.js